import request from './request';

export async function getCoordinates(address) {
    try {
      const encoded = encodeURIComponent(address.trim());
      const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encoded}&key=AIzaSyATTAjkTGESKUljtoMofwUrtxSuFaZlFAc`;
  
      const response = await fetch(url);
      const data = await response.json();
  
      if (data.status === 'OK' && data.results.length > 0) {
        return data.results[0].geometry.location; // { lat, lng }
      } else {
        console.warn('No geocoding result for:', address, data.status);
      }
    } catch (err) {
      console.error('Geocoding error:', err);
    }
  
    return null;
  }
  
  // src/utils/geocode.js
export const getCoordinatesFree = async (address) => {
  const url = `https://photon.komoot.io/api/?q=${encodeURIComponent(address)}`;
  const res = await fetch(url);
  if (!res.ok) return null;
  const { features } = await res.json();
  if (features.length === 0) return null;
  const [lng, lat] = features[0].geometry.coordinates;
  return { lat, lng };
};
